export default __webpack_public_path__ + "static/media/confirmEmailImg.92812f8f.png";